export const dialogBoxStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: "650px",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "10px",
  p: { xs: "40px 31px", sm: "60px" },
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  gap: { xs: "20px", sm: "24px" },
};

export const dialogButtonStyle = {
  borderRadius: "5px",
  width: { xs: "238px", sm: "400px" },
  fontSize: { xs: "10px", sm: "16px" },
};
